<template>
  <div>
    <b-loading is-full-page :active.sync="isLoading"></b-loading>
    <section class="hero is-primary is-bold">
      <div class="hero-body">
        <div class="container">
          <h1 class="title">Ofertas de Emprego</h1>
          <h2 class="subtitle">Todas as ofertas de emprego disponíveis.</h2>
          <!-- USE FOR DEVELOPMENT PURPOSES ONLY TO TEST REGISTER FUNCTIONALITY -->
          <!-- <router-link :to="{ name: 'register' }" class="button is-medium"
            >Register</router-link
          > -->
          <!-- COMMENT FOR PRODUCTION -->
        </div>
      </div>
    </section>
    <section class="section">
      <div v-if="!isLoading && filteredOffers" class="container">
        <div class="columns">
          <div class="column aeisep_filter-col">
            <p class="subtitle">Filtra as propostas por engenharia</p>
            <div class="select is-secondary">
              <select v-model="engenhariaSelecionada">
                <option v-for="engenharia in engenharias" :key="engenharia">
                  {{ engenharia }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-for="(offer, key) in filteredOffers" :key="key" class="card">
          <div v-if="offer.fields.company.fields" class="card-content">
            <div class="content">
              <h1 class="title">
                {{ offer.fields.company.fields.name }}
              </h1>
              <p class="subtitle">
                {{ offer.fields.title }}
              </p>
              <p>
                <router-link
                  :to="{ name: 'offer', params: { offerId: offer.sys.id } }"
                >
                  Clica aqui para abrir esta oferta de emprego e ver toda a
                  informação.
                </router-link>
              </p>
              <b-taglist>
                <b-tag
                  class="is-warning"
                  v-if="$moment(offer.sys.createdAt).isSame($moment(), 'day')"
                >
                  Adicionada hoje
                </b-tag>
                <b-tag
                  class="is-primary"
                  v-for="(category, key) in offer.fields.categories"
                  :key="'category_' + key"
                >
                  {{ category.fields.name }}
                </b-tag>
                <b-tag
                  v-for="(tag, key) in offer.fields.tags"
                  :key="'tag_' + key"
                >
                  {{ tag }}
                </b-tag>
              </b-taglist>
              <time>
                {{ offer.sys.createdAt | moment("LL") }}
              </time>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="container">A carregar ofertas de emprego...</div>
      <div v-if="!isLoading && offersError" class="container">
        Erro ao obter ofertas.
      </div>
      <div v-else-if="!isLoading && offers.length === 0" class="container">
        Nenhuma oferta de emprego encontrada.
      </div>
    </section>
  </div>
</template>

<script>
const contentful = require("contentful");

const client = contentful.createClient({
  space: "7lnt6blrx994",
  accessToken:
    "6d95436eca873871002a45d853336517f9a1cce20c7c1b20e471b2f87eb2f2c9",
});

export default {
  name: "offers-component",
  data() {
    return {
      offers: [],
      isLoading: true,
      activeStatusId: null,
      offersError: false,
      engenhariaSelecionada: "TODAS AS ENGENHARIAS",
      engenharias: [
        "Biorrecursos",
        "Engenharia Biomédica",
        "Engenharia Civil",
        "Engenharia de Geotecnica e Geoambiente",
        "Engenharia de Sistemas",
        "Engenharia de Telecomunicações e Informática",
        "Engenharia Eletrotécnica e de Computadores",
        "Engenharia Eletrotécnica - Sistemas Eléctricos de Energia",
        "Engenharia e Gestão Industrial",
        "Engenharia Informática",
        "Engenharia Mecânica",
        "Engenharia Mecânica Automóvel",
        "Engenharia Química",
        "TODAS AS ENGENHARIAS",
      ],
    };
  },
  created() {
    client
      .getEntries({
        content_type: "offer",
        order: "-sys.createdAt",
      })
      .then((entries) => {
        this.offers = entries.items;
        this.isLoading = false;
      })
      .catch((erro) => {
        console.log(erro);
        this.offersError = true;
        this.isLoading = false;
      });
  },
  computed: {
    filteredOffers() {
      this.isLoading = true;
      if (this.engenhariaSelecionada == "TODAS AS ENGENHARIAS") {
        this.isLoading = false;
        return this.offers;
      } else {
        var filteredOffers = this.offers.filter((offer) => {
          var flag = false;
          offer.fields.categories.forEach((element) => {
            if (element.fields.name == this.engenhariaSelecionada) {
              flag = true;
            }
          });
          return flag;
        });
        this.isLoading = false;
        return filteredOffers;
      }
    },
  },
};
</script>

<style scoped>
.card {
  margin-bottom: 1em;
  background-color: #8b8b8b0c;
}
.tags {
  margin-bottom: 0;
}
.aeisep_filter-col {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/OffersComponent.vue